/* eslint-disable import/no-cycle */
import FileSaver from 'file-saver';
import moment from 'moment';
import LintasAPIService from '../../APIServices/lintasapi';
import { showToast, removeToken } from '../../Utils';
import { getAllSites } from './sites';
import {
  SHOW_USER_FORM_COMMON,
  PRIMARY_FILTERS,
  ASSIGN_PRODUCT,
  GET_ESTIMATES,
  AUTH_USER,
  FILTER_COMPANIES,
  FILTER_PRODUCTS,
  FILTER_CLIENTS,
  LOADER,
  DASHBOARD_DATA,
  ALL_SITES,
  GET_STATES,
  GET_CITIES,
  ERROR_DIALOG,
  FILTER_SUPPLIERS,
  FILTER_RO,
  FILTER_CLIENTS_DASHBOARD,
  FILTER_PRODUCTS_CLIENTS_DASHBOARD,
  FILTER_CAMPAIGNS_CLIENTS_DASHBOARD,
  FILTER_SITES_CLIENTS_DASHBOARD,
  FILTER_CLIENTS_CAMPAIGNS,
  FILTER_CLIENTS_DASHBOARD_DATA,
  FILTER_ESTIMATES_CLIENTS_DASHBOARD,
  FILTER_SITES_AUDITOR_DASHBOARD,
} from '../actionTypes';

const apiCall = new LintasAPIService();

export const errorDialogAction = ({ val }) => (dispatch) => {
  dispatch({
    type: ERROR_DIALOG,
    payload: val,
  });
};

export const loader = (val) => (dispatch) => {
  dispatch({
    type: LOADER,
    payload: val,
  });
};

export const showUserForm = (val) => (dispatch) => {
  dispatch({
    type: SHOW_USER_FORM_COMMON,
    payload: val,
  });
};

export const handleLogin = () => (dispatch) => {
  dispatch({
    type: AUTH_USER,
    payload: true,
  });
};

export const handleErrorLocal = (err) => (dispatch) => {
  if (err.response === undefined) {
    const msg = 'Something went wrong.';
    dispatch(errorDialogAction({ val: msg }));
  } else {
    switch (err.response.status) {
      case 401: {
        removeToken();
        dispatch({
          type: AUTH_USER,
          payload: false,
        });
        break;
      }
      case 400:
      case 500:
      case 404: {
        const msg = err.response.data.message || 'Something went wrong.';
        dispatch(errorDialogAction({ val: msg }));
        break;
      }
      case 501: {
        const msg = err.response.data.message
          || 'Incorrect query or invalid column value';
        dispatch(errorDialogAction({ val: msg }));
        break;
      }
      case 502: {
        const msg = err.response.data.message || 'Error code 502: Something went wrong.';
        dispatch(errorDialogAction({ val: msg }));
        break;
      }
      case 409: {
        const msg = err.response.data.message || 'Duplicate entry';
        dispatch(errorDialogAction({ val: msg }));
        break;
      }
      case 410: {
        dispatch(errorDialogAction({ val: 'Unable to delete!' }));
        break;
      }
      default: {
        const msg = err.response.data.message || 'Something went wrong.';
        dispatch(errorDialogAction({ val: msg }));
        break;
      }
    }
  }
};

export const getPrimaryFilters = () => (dispatch) => {
  apiCall
    .getPrimaryFilters()
    .then((response) => dispatch({
      type: PRIMARY_FILTERS,
      payload: response.data,
    }))
    .catch((err) => {
      dispatch(handleErrorLocal(err));
    });
};

export const getCompanies = () => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getCompanies()
    .then((response) => {
      dispatch(loader(false));
      dispatch({
        type: FILTER_COMPANIES,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const getClientsByCompanyCode = (companyCode) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getClientsByCompanyCode(companyCode)
    .then((response) => {
      if (response.data.clients.length === 0) {
        showToast('info', response.data.message);
      }
      dispatch(loader(false));
      dispatch({
        type: FILTER_CLIENTS,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const getProductsByClientId = (clientId) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getProductsByClientId(clientId)
    .then((response) => {
      if (response.data.products.length === 0) {
        showToast('info', response.data.message);
      }
      dispatch(loader(false));
      dispatch({
        type: FILTER_PRODUCTS,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const assignProduct = (data) => (dispatch) => {
  apiCall
    .assignProduct(data)
    .then((response) => {
      showToast('success', response.data.message);
      dispatch({
        type: ASSIGN_PRODUCT,
        payload: response.data,
        productId: data.brands[0],
      });
    })
    .catch((err) => {
      dispatch(handleErrorLocal(err));
    });
};

export const getEstimates = (filter) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getEstimates(filter)
    .then((response) => {
      const { estimates } = response.data;
      dispatch(loader(false));
      if (estimates && estimates.length === 0) {
        showToast('info', 'Estimates not found');
      }
      dispatch({
        type: GET_ESTIMATES,
        payload: estimates,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const handleLogout = () => (dispatch) => {
  localStorage.clear();
  dispatch({
    type: AUTH_USER,
    payload: false,
  });
};

export const resetPassword = (data, userId) => (dispatch) => {
  apiCall
    .resetPassword(data, userId)
    .then((response) => {
      showToast('success', response.data.message);
      return true;
    })
    .catch((err) => {
      dispatch(handleErrorLocal(err));
    });
};

export const dashboardReports = (filter = 'week') => (dispatch) => {
  apiCall
    .dashboardReports(filter)
    .then((response) => dispatch({
      type: DASHBOARD_DATA,
      payload: response.data,
    }))
    .catch((err) => {
      dispatch(handleErrorLocal(err));
    });
};

export const exportVendorUsers = (supplierId = null) => (dispatch) => {
  apiCall
    .exportVendorUsers(supplierId)
    .then((response) => {
      const type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
      const blob = new Blob([response.data], { type });
      const fileName = `monitors-${moment().format(
        'DD-MM-YYYY-HH-mm-ss',
      )}.xlsx`;
      FileSaver.saveAs(blob, fileName);
    })
    .catch((err) => {
      dispatch(handleErrorLocal(err));
    });
};

export const exportSites = (estimateId) => (dispatch) => {
  apiCall
    .exportSites(estimateId)
    .then((response) => {
      const type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
      const blob = new Blob([response.data], { type });
      const fileName = `estimate-${estimateId}-${moment().format(
        'DD-MM-YYYY-HH-mm-ss',
      )}-sites.xlsx`;
      FileSaver.saveAs(blob, fileName);
    })
    .catch((err) => {
      dispatch(handleErrorLocal(err));
    });
};

export const exportSitesForDefaultPicture = (estimateId, siteIds) => (dispatch) => {
  apiCall
    .exportSitesForDefaultPicture(estimateId, siteIds)
    .then((response) => {
      const type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
      const blob = new Blob([response.data], { type });
      const fileName = `estimate-${estimateId}-${moment().format(
        'DD-MM-YYYY-HH-mm-ss',
      )}-sites.xlsx`;
      FileSaver.saveAs(blob, fileName);
    })
    .catch((err) => {
      dispatch(handleErrorLocal(err));
    });
};

export const importSites = (file, estimateId) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .importSites(file, estimateId)
    .then((response) => {
      dispatch(loader(false));
      showToast('success', response.data.message);
      dispatch({
        type: ALL_SITES,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const importSitesDefaultPicture = (
  file, estimateId, page, searchQuery, primaryQuery,
) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .importSitesDefaultPicture(file, estimateId)
    .then((response) => {
      showToast('success', response.data.message);
      dispatch(getAllSites(page, searchQuery, primaryQuery))
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const exportCompeteSiteReports = (estimateId) => (dispatch) => {
  apiCall
    .exportCompleteSiteReport(estimateId)
    .then((response) => {
      const type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
      const blob = new Blob([response.data], { type });
      const fileName = `estimate-${estimateId}-${moment().format(
        'DD-MM-YYYY-HH-mm-ss',
      )}-sites-complete-report.xlsx`;
      FileSaver.saveAs(blob, fileName);
    })
    .catch((err) => {
      dispatch(handleErrorLocal(err));
    });
};

export const getAllStates = () => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getStates()
    .then((response) => {
      dispatch(loader(false));
      dispatch({
        type: GET_STATES,
        payload: response.data.data,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const getAllCities = (stateId = 0) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getCities(stateId)
    .then((response) => {
      dispatch(loader(false));
      dispatch({
        type: GET_CITIES,
        payload: response.data.data,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const exportSuppliers = () => (dispatch) => {
  apiCall
    .exportSuppliers()
    .then((response) => {
      const type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
      const blob = new Blob([response.data], { type });
      const fileName = `suppliers-${moment().format(
        'DD-MM-YYYY-HH-mm-ss',
      )}.xlsx`;
      FileSaver.saveAs(blob, fileName);
    })
    .catch((err) => {
      dispatch(handleErrorLocal(err));
    });
};

export const syncClients = () => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .syncClients()
    .then(() => {
      dispatch(loader(false));
      showToast('success', 'Clients synced successfully!');
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const syncProducts = () => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .syncProducts()
    .then(() => {
      dispatch(loader(false));
      showToast('success', 'Products synced successfully!');
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const syncCities = () => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .syncCities()
    .then(() => {
      dispatch(loader(false));
      showToast('success', 'Cities synced successfully!');
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const syncStates = () => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .syncStates()
    .then(() => {
      dispatch(loader(false));
      showToast('success', 'States synced successfully!');
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const syncSuppliers = () => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .syncSuppliers()
    .then(() => {
      dispatch(loader(false));
      showToast('success', 'Suppliers synced successfully!');
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const fetchReport = (sd, ed, query) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .fetchReport({ sd, ed, query })
    .then((response) => {
      const type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
      const blob = new Blob([response.data], { type });
      const fileName = `report-${sd}-to-${ed}.xlsx`;
      FileSaver.saveAs(blob, fileName);
      dispatch(loader(false));
    })
    .catch((err) => {
      if (err && err.response && err.response.status && err.response.status === 404) {
        // eslint-disable-next-line no-param-reassign
        err.response.data.message = 'No data found for selected filter';
      }
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};
export const ataFetchReport = (sd, ed, query) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .ataFetchReport({ sd, ed, query })
    .then((response) => {
      const type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
      const blob = new Blob([response.data], { type });
      const fileName = `ata-report-${sd}-to-${ed}.xlsx`;
      FileSaver.saveAs(blob, fileName);
      dispatch(loader(false));
    })
    .catch((err) => {
      if (err && err.response && err.response.status && err.response.status === 404) {
        // eslint-disable-next-line no-param-reassign
        err.response.data.message = 'No data found for selected filter';
      }
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};
export const getSuppliersByCompany = (companyCode) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getSuppliersByCompany(companyCode)
    .then((response) => {
      if (response.data.suppliers.length === 0) {
        showToast('info', response.data.message);
      }
      dispatch(loader(false));
      dispatch({
        type: FILTER_SUPPLIERS,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const getROByClient = (clientCode) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getROByClient(clientCode)
    .then((response) => {
      if (response.data.ro.length === 0) {
        showToast('info', response.data.message);
      }
      dispatch(loader(false));
      dispatch({
        type: FILTER_RO,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

// Client dashboard api function

export const getClients = () => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getClients()
    .then((response) => {
      dispatch(loader(false));
      dispatch({
        type: FILTER_CLIENTS_DASHBOARD,
        payload: response.data.clients,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const getProductByClientId = (clientId) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getProductByClientId(clientId)
    .then((response) => {
      if (response.data.products.length === 0) {
        showToast('info', response.data.message);
      }
      dispatch(loader(false));
      dispatch({
        type: FILTER_PRODUCTS_CLIENTS_DASHBOARD,
        payload: response.data.products,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const getCampaignsByProductCode = (productCode) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getCampaignsByProductCode(productCode)
    .then((response) => {
      if (response.data.campaigns.length === 0) {
        showToast('info', response.data.message);
      }
      dispatch(loader(false));
      dispatch({
        type: FILTER_CAMPAIGNS_CLIENTS_DASHBOARD,
        payload: response.data.campaigns,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const getEstimatesByProductCode = (productCode) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getEstimatesByProductCode(productCode)
    .then((response) => {
      if (response.data.estimates.length === 0) {
        showToast('info', response.data.message);
      }
      dispatch(loader(false));
      dispatch({
        type: FILTER_ESTIMATES_CLIENTS_DASHBOARD,
        payload: response.data.estimates,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const getSitesByCampaignNo = (campaignNo) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getSitesByCampaignNo(campaignNo)
    .then((response) => {
      if (response.data.data.length === 0) {
        showToast('info', response.data.message);
      }
      dispatch(loader(false));
      dispatch({
        type: FILTER_SITES_CLIENTS_DASHBOARD,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const getSitesByEstimateNo = (estimateNo, status, searchQuery) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getSitesByEstimateNo(estimateNo, status, searchQuery)
    .then((response) => {
      if (response.data.data.length === 0) {
        showToast('info', response.data.message);
      }
      dispatch(loader(false));
      dispatch({
        type: FILTER_SITES_AUDITOR_DASHBOARD,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const atrFetchReport = (campaignNo, isFOC) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .atrFetchReport(campaignNo)
    .then((response) => {
      const type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
      const blob = new Blob([response.data], { type });
      const fileName = `${isFOC ? 'foc-report' : 'atr-report'}-${campaignNo.campaignNo}.xlsx`;
      FileSaver.saveAs(blob, fileName);
      dispatch(loader(false));
    })
    .catch((err) => {
      if (err && err.response && err.response.status && err.response.status === 404) {
        // eslint-disable-next-line no-param-reassign
        err.response.data.message = 'No data found for selected filter';
      }
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const getClientCampaigns = () => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getClientCampaigns()
    .then((response) => {
      dispatch(loader(false));
      dispatch({
        type: FILTER_CLIENTS_CAMPAIGNS,
        payload: response.data.campaigns,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};

export const getClientDashboardData = ({ campaignNo, time }) => (dispatch) => {
  dispatch(loader(true));
  apiCall
    .getClientDashboardData({ campaignNo, time })
    .then((response) => {
      if (response.data.length === 0) {
        showToast('info', response.data.message);
      }
      dispatch(loader(false));
      dispatch({
        type: FILTER_CLIENTS_DASHBOARD_DATA,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch(loader(false));
      dispatch(handleErrorLocal(err));
    });
};
